export const ROUTES = {
  HOME: {
    label: 'Home',
    path: '/',
    mainNav: false,
  },
  SIGNIN_CALLBACK: {
    path: '/signin-callback',
    mainNav: false,
  },
} as const;
